import { AppointmentType } from 'src/services/availability';
import { BookingUserProfileModel } from 'src/services/booking';
import { isExpressTelehealth, isFaceToFace, newPatientRegex } from 'src/utils/appointmentTypes';

export * from './BookWithClinicForm';
export * from './BookWithDoctorForm';

export type AppointmentMode = 'faceToFace' | 'telehealth' | 'express telehealth';
export type PatientType = 'existing' | 'new';

export type BookingInformationForm = {
    patientType: PatientType;
    appointmentMode: AppointmentMode;
    appointmentTypeId: string;
    siteId: string;
    doctorId: string;
};

export function filterToAppointmentMode(apt: AppointmentType, mode: AppointmentMode): boolean {
    switch (mode) {
        case 'faceToFace':
            return isFaceToFace(apt);
        case 'telehealth':
            return !isFaceToFace(apt) && !isExpressTelehealth(apt);
        case 'express telehealth':
            return isExpressTelehealth(apt);
    }
}

function filterAppointmentType(apt: AppointmentType, patientType: PatientType, appointmentMode: AppointmentMode) {
    return (
        filterToAppointmentMode(apt, appointmentMode) &&
        (apt.newPatient || patientType === 'existing') &&
        (patientType !== 'existing' || !apt.appointmentName.match(newPatientRegex))
    );
}

export function filterAppointmentTypesForClinic(
    appointmentTypes: AppointmentType[],
    patientType: PatientType,
    appointmentMode: AppointmentMode
) {
    return appointmentTypes.filter((apt) => filterAppointmentType(apt, patientType, appointmentMode));
}

export function filterAppointmentTypesForDoctor(
    appointmentTypes: AppointmentType[],
    patientType: PatientType,
    appointmentMode: AppointmentMode,
    doctorDetails: BookingUserProfileModel
) {
    return appointmentTypes.filter(
        (apt) =>
            filterAppointmentType(apt, patientType, appointmentMode) &&
            (doctorDetails
                ? doctorDetails.apptTypeIds.includes(Number(apt.appointmentTypeId)) &&
                  (patientType === 'existing' || !doctorDetails.noNewPatient)
                : true)
    );
}
